import { render } from "./portafolio.vue?vue&type=template&id=17eb3dce&scoped=true"
import script from "./portafolio.vue?vue&type=script&lang=js"
export * from "./portafolio.vue?vue&type=script&lang=js"

import "./portafolio.vue?vue&type=style&index=0&id=17eb3dce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17eb3dce"]])

export default __exports__